export const optanonConsentCookieName = "OptanonConsent";
